export default __webpack_public_path__ + "static/media/s3.43317783.png";